import axios from 'axios';
import { Auth } from 'aws-amplify';
import { enqueueSnackbar } from 'notistack';

// prefer runtime (window._env_) env vars over build time (process.env)
export const xpertly_host = window?._env_?.REACT_APP_XPERTLY_HOST || process.env.REACT_APP_XPERTLY_HOST;
export const ssl = window?._env_?.REACT_APP_SSL || process.env.REACT_APP_SSL;
export const http_protocol = ssl ? "https" : "http";
export const ws_protocol = ssl ? "wss" : "ws";
export const xpertly_api_root = http_protocol + "://" + xpertly_host + "/api";
export const user_api_root = http_protocol + "://" + xpertly_host + "/users";
export const xpertly_ws = ws_protocol + "://" + xpertly_host + "/ws";
export const avicenna_api_root = http_protocol + "://" + xpertly_host + "/avicenna/api";

console.log(xpertly_host);
console.log(ssl);
console.log(http_protocol);
console.log(ws_protocol);
console.log(xpertly_api_root);
console.log(user_api_root);
console.log(xpertly_ws);
// setup the intercepter here
// handle 400 error
axios.interceptors.request.use(async (config) => {
  try {
    const session = await Auth.currentSession();
    config.headers.Authorization = session.getAccessToken().getJwtToken();
  } catch (e) {
    console.log(e);
  }
  // if (config.method === 'get') {
  //   dispatch(loading());
  // }
  return config;
}, (e) => Promise.reject(e));

axios.interceptors.response.use((response) => {
  // if (response.config.method === 'get') {
  //   dispatch(loaded());
  // }
  return response;
}, (e) => {
  if (e?.response) {
    switch (e.response.status) {
      case 200:
        break;
      case 401:
        if (e.response.data && e.response.data.message) {
          enqueueSnackbar(e.response.data.message, { variant: 'error' });
          // platform.insertError(e.response.data.message);
        } else if (window.location.href.endsWith('/view')) {
          window.location.href = '/unauthorised?redirect_uri=' + window.location.pathname;
        } else {
          enqueueSnackbar('You are unauthorised for this action.', { variant: 'error' });
          // platform.insertError('You are unauthorised for this action.')
        }
        break;
      case 403:
        if (e.response.data && e.response.data.message) {
          enqueueSnackbar(e.response.data.message, { variant: 'error' });
          // platform.insertError(e.response.data.message);
        } else if (window.location.href.endsWith('/view')) {
          window.location.href = '/forbidden';
        } else {
          enqueueSnackbar('You are unauthorised for this action.', { variant: 'error' });
        }
        break;
      case 404:
        if (window.location.href.endsWith('/view')) {
          window.location.href = '/worker-notfound';
        }
        break;
      case 409:
        if (e.response.data) {
          enqueueSnackbar(e.response.data, { variant: 'error' });
          // platform.insertError(e.response.data.message);
        }
        break;
      case 500:
        enqueueSnackbar('Unexpected error occurred.', { variant: 'error' });
        // platform.insertError('Unexpected error occurred.');
        break;
      default:
        enqueueSnackbar(e?.response?.data?.message || 'Unkown error.', { variant: 'error' });
    }
  }

  return Promise.resolve(e?.response);
});
